export const KUX_FEATURE_NAME = 'kuxmanaged';
export const READ_ONLY_FEATURE_NAME = 'readonly';
export const METADATA_FEATURE_NAME = 'metadata';
// export const VIRTUAL_ASSET_FEATURE_NAME = 'ObjectVirtualAsset';

export const CATEGORY_ID_SYSTEM_NAME = 'CategoryId';
export const BASIC_METAS = [
  'Name',
  'Description',
  'ExternalID',
  'Status',
  'EntryID',
  'PlaybackStartDateTime',
  'PlaybackEndDateTime',
  'CatalogStartDateTime',
  'CatalogEndDateTime',
  'CreateDate',
  CATEGORY_ID_SYSTEM_NAME,
];

export const META_NULLABLE = 'nullable'; // Meta available to be reset / to have null value
export const META_ENUMERATION_TYPE = 'enumeration_type';
export const META_ENUMERATION_TYPE_MULTIPLE = 'enumeration_type_multiple';

export const MAIN_VIRTUAL_ASSET_STRUCT_NAME = 'Category';
export const META_KSQL = ['filtering_kSQL'];

export enum PREDEFINED_REFERENCES {
  'home' = 'homepage',
  'epg' = 'epg_page',
  'recordings' = 'recordings_page',
  'search' = 'search_page',
  'grid' = 'default_grid',
  'subscriptionRail' = 'subscription_rail',
}
